import {
  $KnowAndShowLevel,
  GoalsIndexPhase,
  GymMode,
  JtfMode,
  KnowAndShowLevel,
  SpecialGradeLevel,
} from '@suntex.fim/enums';

/**
 * Maps a grade level to the corresponding GoalsIndex phase.
 * - Early: K-2
 * - Elementary: 3-4
 * - Intermediate: 5-6
 * - Advanced: 7-8
 */
export function gradeToPhase(grade: SpecialGradeLevel): GoalsIndexPhase {
  // Early phase: Kindergarten through Grade 2
  if (grade <= SpecialGradeLevel.Grade2) {
    return GoalsIndexPhase.Early;
  }

  // Elementary phase: Grades 3-4
  if (grade >= SpecialGradeLevel.Grade3 && grade <= SpecialGradeLevel.Grade4) {
    return GoalsIndexPhase.Elementary;
  }

  // Intermediate phase: Grades 5-6
  if (grade >= SpecialGradeLevel.Grade5 && grade <= SpecialGradeLevel.Grade6) {
    return GoalsIndexPhase.Intermediate;
  }

  // Advanced phase: Grades 7-8
  if (grade >= SpecialGradeLevel.Grade7 && grade <= SpecialGradeLevel.Grade8) {
    return GoalsIndexPhase.Advanced;
  }

  // Fallback for any unexpected or out-of-range grade values
  return GoalsIndexPhase.Elementary;
}

/**
 * Maps a grade level to the corresponding Gym assessment mode.
 * - K2: K-2
 * - WholeNumbers: 3-4
 * - Fractions: 5
 * - Decimals: 6
 * - Integers: 7-8
 */
export function gradeToGymLevel(grade: SpecialGradeLevel): GymMode {
  if (grade <= SpecialGradeLevel.Grade2) {
    return GymMode.K2;
  }

  if (grade >= SpecialGradeLevel.Grade3 && grade <= SpecialGradeLevel.Grade4) {
    return GymMode.WholeNumbers;
  }

  if (grade === SpecialGradeLevel.Grade5) {
    return GymMode.Fractions;
  }

  if (grade === SpecialGradeLevel.Grade6) {
    return GymMode.Decimals;
  }

  if (grade >= SpecialGradeLevel.Grade7 && grade <= SpecialGradeLevel.Grade8) {
    return GymMode.Integers;
  }

  return GymMode.WholeNumbers;
}

/**
 * Maps a grade to the first Know and Show level offered by its report phase.
 */
export function gradeToKnowAndShowLevel(
  grade: SpecialGradeLevel,
): KnowAndShowLevel {
  if (grade === SpecialGradeLevel.Kindergarten) {
    return KnowAndShowLevel.KS1;
  }

  if (grade >= SpecialGradeLevel.Grade1 && grade <= SpecialGradeLevel.Grade8) {
    return $KnowAndShowLevel.from(grade);
  }

  if (grade >= SpecialGradeLevel.Grade9 && grade <= SpecialGradeLevel.Grade12) {
    return KnowAndShowLevel.KS8;
  }

  return KnowAndShowLevel.KS3;
}

/**
 * Maps a grade to its default Just the Facts mode.
 */
export function gradeToJtfMode(grade: SpecialGradeLevel): JtfMode {
  switch (grade) {
    case SpecialGradeLevel.Grade5:
      return JtfMode.Fractions;
    case SpecialGradeLevel.Grade6:
      return JtfMode.Decimals;
    case SpecialGradeLevel.Grade7:
    case SpecialGradeLevel.Grade8:
      return JtfMode.Integers;
    case SpecialGradeLevel.Grade9:
    case SpecialGradeLevel.Grade10:
    case SpecialGradeLevel.Grade11:
    case SpecialGradeLevel.Grade12:
      return JtfMode.Fractions;
    default:
      return JtfMode.WholeNumbers;
  }
}
